import { apiClient } from '@/lib/api-client';
import { API_ROUTES } from '@/lib/api-config';
import type { ProductWithCategory, ProductsResponse } from '@/types/product.types';

/**
 * Get all products with their categories (normalized format)
 */
export const getAllProducts = async (): Promise<ProductsResponse> => {
  return apiClient.get<ProductsResponse>(API_ROUTES.PRODUCTS);
};

/**
 * Get featured products for homepage (normalized format)
 */
export const getFeaturedProducts = async (): Promise<ProductsResponse> => {
  return apiClient.get<ProductsResponse>(`${API_ROUTES.PRODUCTS}?featured=true`);
};

/**
 * Get a single product by ID
 */
export const getProductById = async (id: string): Promise<ProductWithCategory> => {
  return apiClient.get<ProductWithCategory>(API_ROUTES.PRODUCT_BY_ID(id));
};
